<template>
    <div class="custom-actions">
        <label> Responsabili </label>
        <select class="form-control" @change="getChilds($event)"  :value="this.item_selected" >
            <option v-for="(label,index) in select_data" :value="index">{{ label }}</option>
        </select>

        <label> Dipendente </label>
        <select v-model="goToCollaborator"  @change="goToView($event)">
            <option v-for="(label,index) in collaborators" :value="index">
                {{ label }}
            </option>
        </select>

    </div>
  </template>

<script>
    export default {
        mounted() {
            //
        },
        props: {
            select_data: {
                type: Array,
                required: true
            },
            collaborators: {
                type: Array,
                required: true
            },
            next_view :{
                type: String,
                required : true
            },
            item_selected:{
                type: Number,
                required : true
            },
            item_selected2:{
                type: Number,
                required : true
            },
            extra_param:{
                type: String,
                required : false,
                default:''
            },
            compensations_session:{
                type: Number,
                required: true
            },
            label_dropdown:{
                type: String,
                required : false
            }
        },

        data()  {
            return {
                collaborators : null,
                goToCollaborator : null
            }
        },
        methods: {

            getChilds(event){
                //this.select_data=event.target.value;
                axios.get("/people-collaborators/"+event.target.value+"/person?compensations_session= "+this.compensations_session)
                    .then((response) => {
                      //  console.log(response.data);
                        this.collaborators = response.data;
                    });
            },
            goToView(event){
                window.location.href= "/"+this.next_view+event.target.value+this.extra_param;
            }
        }
    }
</script>

<style>
.custom-actions button.ui.button {
  padding: 8px 8px;
}
.custom-actions button.ui.button > i.icon {
  margin: auto !important;
}
</style>
